import {
  FormControl,
  FormLabel,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
} from '@chakra-ui/react'
import { Controller } from 'react-hook-form'

import useUnregisterDefaultValueField from '../../hooks/useUnregisterDefaultValueField'
import useSetDefaultValueOnNotArrayData from '../../hooks/useSetDefaultValueOnNotArrayData'
import { DefaultValueCommonProps } from '../../types/DefaultValueCommonProps'

export default function DefaultValueNumber({ formMethods, question }: DefaultValueCommonProps) {
  useUnregisterDefaultValueField({ formMethods })

  useSetDefaultValueOnNotArrayData({ formMethods, question })

  return (
    <FormControl display="flex" flexDir="column" gap={2}>
      <FormLabel fontWeight="bold">Valor inicial</FormLabel>
      <Controller
        name="default_value"
        control={formMethods.control}
        render={({ field }) => (
          <NumberInput
            {...field}
            value={field.value ?? 0}
            onChange={(valueString) => field.onChange(Number(valueString))}
          >
            <NumberInputField />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
        )}
      />
    </FormControl>
  )
}
